import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", null, [
      _createElementVNode("path", {
        id: "__Path_864_2_",
        d: "M22.89,14.05c1.53-0.01,2.76-1.25,2.76-2.77c-0.01-1.53-1.25-2.76-2.77-2.76\r\n\t\tc-1.53,0.01-2.76,1.25-2.76,2.77C20.12,12.82,21.36,14.05,22.89,14.05C22.89,14.05,22.89,14.05,22.89,14.05z"
      }),
      _createElementVNode("path", { d: "M22.9,41c-2.26,0-4.35-0.97-5.78-2.66c-1.43-1.69-2.05-3.9-1.69-6.09c0.27-1.64,0.82-2.78,1.35-3.88\r\n\t\tc0.73-1.52,1.43-2.95,1.43-5.85c0-2.96-0.69-4.39-1.43-5.91c-0.53-1.1-1.08-2.23-1.35-3.88c-0.36-2.18,0.26-4.4,1.69-6.09\r\n\t\tC18.55,4.97,20.64,4,22.86,4c2.26,0,4.35,0.97,5.79,2.66c1.43,1.69,2.05,3.9,1.69,6.09c-0.27,1.64-0.82,2.78-1.35,3.88\r\n\t\tc-0.73,1.52-1.43,2.95-1.43,5.85v0.06c0,2.9,0.69,4.34,1.43,5.85c0.53,1.1,1.08,2.23,1.35,3.88c0.36,2.18-0.26,4.4-1.69,6.09\r\n\t\tC27.21,40.03,25.12,41,22.9,41z M22.9,6c-1.67,0-3.21,0.71-4.26,1.95c-1.05,1.24-1.5,2.87-1.24,4.47c0.22,1.36,0.69,2.32,1.18,3.33\r\n\t\tc0.76,1.58,1.62,3.36,1.62,6.72c0,3.42-0.86,5.2-1.62,6.78c-0.49,1.02-0.96,1.97-1.18,3.33c-0.26,1.6,0.19,3.23,1.24,4.47\r\n\t\tc1.05,1.24,2.59,1.95,4.22,1.95c1.67,0,3.21-0.71,4.26-1.95c1.05-1.24,1.5-2.87,1.24-4.47c-0.22-1.36-0.69-2.32-1.18-3.33\r\n\t\tc-0.76-1.58-1.62-3.36-1.62-6.72v-0.06c0-3.36,0.86-5.15,1.62-6.72c0.49-1.02,0.96-1.97,1.18-3.33c0.26-1.6-0.19-3.23-1.24-4.47\r\n\t\tC26.07,6.71,24.53,6,22.9,6z" }),
      _createElementVNode("path", {
        id: "__Path_864_3_",
        d: "M22.87,30.95c-1.53,0.01-2.76,1.25-2.76,2.77c0.01,1.53,1.25,2.76,2.77,2.76\r\n\t\tc1.53-0.01,2.76-1.25,2.76-2.77C25.64,32.18,24.4,30.95,22.87,30.95C22.87,30.95,22.87,30.95,22.87,30.95z"
      })
    ], -1))
  ]))
}
export default { render: render }